import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { Paper, FlatButton, Toggle } from 'material-ui';
import { Link } from 'react-router';
import { push as pushAction, goBack as goBackAction } from 'react-router-redux';
import ArrowForwardIcon from 'material-ui/svg-icons/navigation/chevron-right';
import ActivityIcon from 'material-ui/svg-icons/action/question-answer';
import InternalNoteIcon from 'material-ui/svg-icons/action/speaker-notes';
import WorkspaceIcon from 'material-ui/svg-icons/action/view-day';
import moment from 'moment';
import R from 'ramda';
import PartnerNode from '../partner-node';
import UpdateAssignee from '../../../generic-components/update-assignee';
import AddEditContractDialog from '../../draftNTemplate-container/add-edit-contract-dialog';
import UpdateRateConversionPriority from '../../../dummy-account/update-rate-conversion-priority';
import UpdateRateConversionStatus from '../../../dummy-account/update-rate-conversion-status';
import { JiraFlatButton } from '../../../../tc-ui/small-buttons';
import ResendContract from '../../contract-container/dialogs/resend-or-update-dialog';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import EmailTracking from '../../../comments/email-tracking';
import LoadingOverlay from '../../../../tc-ui/loading-overlay';
import CheckIcon from 'material-ui/svg-icons/action/check-circle';

import {
  getContractLeftNav as getContractLeftNavAction,
  getContractDetails as getContractDetailsAction,
  getHistoryFeeds as getHistoryFeedsAction,
} from '../../../../../stores/contracting/contract-activities-products/contract-activities-products-actions';

import { getNotes as getNotesAction } from '../../../__storeFiles__/actions';

const propTypes = {
  contractId: PropTypes.string,
  buyerInfo: PropTypes.object,
  notesCount: PropTypes.number,
  contractorEditable: PropTypes.bool,
  openAddEditContractDialog: PropTypes.func,
  isLatest: PropTypes.bool,
  from: PropTypes.object,
  to: PropTypes.object,
  deadlineDate: PropTypes.string,
  lastSent: PropTypes.string,
  rateConversionStatus: PropTypes.string,
  rateConversionSetting: PropTypes.string,
  respondedContracts: PropTypes.array,
  files: PropTypes.array,
  getContractLeftNav: PropTypes.func,
  params: PropTypes.object,
  getContractDetails: PropTypes.func,
  assignee: PropTypes.object,
  priority: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  openResendContractDialog: PropTypes.func,
  payloadForResend: PropTypes.object,
  leftNavLoaded: PropTypes.bool,
  push: PropTypes.func,
  goBack: PropTypes.func,
  children: PropTypes.any,
  getHistoryFeeds: PropTypes.func,
  mostRecentSentActivity: PropTypes.object,
  contractingRemindersSettings: PropTypes.array,
  shouldSendReminders: PropTypes.bool,
  buyerChecked: PropTypes.bool,
  createdAt: PropTypes.string,
  updateWorkspace: PropTypes.func,
  getNotes: PropTypes.func,
};

class CRBuyerView extends Component {
  constructor() {
    super();
    this.state = {
      showRecipients: false,
    };
  }
  componentWillMount() {
    const { leftNavLoaded, params, getContractDetails, getContractLeftNav, getHistoryFeeds } = this.props;
    if (!leftNavLoaded) {
      getContractDetails('contract', params.contractId);
      getContractLeftNav('contract', params.contractId);
      getHistoryFeeds('contract', params.contractId);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.leftNavLoaded && !this.props.leftNavLoaded) {
      this.props.getNotes({ historyFeedId: nextProps.historyFeedId })
    }
  }

  clickShowRecipients = () => this.setState({ showRecipients: !this.state.showRecipients });
  resendContract = () => this.props.openResendContractDialog(
    this.props.payloadForResend
  );
  updateContractPeriod = () => this.props.openAddEditContractDialog({
    type: 'UpdateContractPeriod',
    data: {
      title: 'Update Contract Period',
      newStartDate: this.props.startDate,
      newEndDate: this.props.endDate,
      startDate: this.props.startDate,
      endDate: this.props.endDate,
    },
  });
  goToDocuments = () => this.props.contractId
    ? this.props.push(`/contracting/workspace/${this.props.contractId}/documents`)
    : null;
  goToNotes = () => this.props.contractId
    ? this.props.push(`/contracting/workspace/${this.props.contractId}/notes`)
    : null;
  goToActivities = () => this.props.contractId
  ? this.props.push(`/contracting/workspace/${this.props.contractId}/activities`)
  : null;
  goToWorkspaceList = () => {
    window.location = `${process.env.NEW_SYSTEM_URL}/contracting/workspace-list?jwt=${localStorage.getItem('jwt')}`;
  };
  onClickShouldSendReminders = () => {
    this.props.updateWorkspace({
      contractId: this.props.contractId,
      updater: { shouldSendReminders: !this.props.shouldSendReminders },
    });
  }
  render() {
    const {
      contractId,
      notesCount,
      startDate,
      endDate,
      deadlineDate,
      createdAt,
      to = {},
      rateConversionStatus = '',
      assignee,
      priority,
      children,
      mostRecentSentActivity,
      contractingRemindersSettings,
      shouldSendReminders,
      buyerChecked,
      respondedContracts = [],
      files = [],
    } = this.props;
    const reminderBasicRequirementMet = Boolean(
      mostRecentSentActivity
      && deadlineDate
      && rateConversionStatus.toLowerCase().indexOf('complete') === -1
      && !(buyerChecked || respondedContracts.length || files.length)
    );
    const reminderDates = contractingRemindersSettings.map(o => {
      let date;
      const fromDate = o.fromDate === 'deadline' ? deadlineDate : createdAt;
      if (o.priorAfter === 'prior') date = moment(fromDate).subtract(o.days, 'days').toISOString();
      else date = moment(fromDate).add(o.days, 'days').toISOString();
      return {
        ...o,
        date,
      };
    }).filter(o => o.enabled && o.date && moment(o.date).isSameOrAfter(new Date()))
    .sort(R.ascend(R.prop('date')));
    const reminderRequirements = {
      'Rate Request was sent': Boolean(mostRecentSentActivity && deadlineDate),
      'Status is not complete': rateConversionStatus.toLowerCase().indexOf('complete') === -1,
      'Rates are not yet received.': !(buyerChecked || respondedContracts.length || files.length),
      'Company Settings': Boolean(reminderDates.length),
    };
    const pathN = window.location.pathname;
    const isHealthAndSafety = new Date(startDate).getUTCFullYear() === 2099;
    return (
      <div>
        <div className="flex-tc-sb" style={{ padding: '0.5em 1em', backgroundColor: '#00bcd4', color: '#fff' }}>
          <div className="flex-center">
            <div style={{ fontSize: '1.5em', cursor: 'pointer' }} onClick={this.goToWorkspaceList}>
              Workspace List
            </div>
            <ArrowForwardIcon style={{ height: '36px', width: '36px', color: '#fff' }}/>
            <div>
              <b>{to.name || ''}</b>
              &nbsp;
              {
                isHealthAndSafety
                ? `Health & Safety`
                : `${
                  startDate ? moment.utc(new Date(startDate)).format('MMM DD YYYY') : ''
                  } - ${
                  endDate ? moment.utc(new Date(endDate)).format('MMM DD YYYY') : ''
                  }`
              }
              &nbsp;Workspace
            </div>
          </div>
          <div className="flex-center">
            <FlatButton
              icon={<WorkspaceIcon style={{ color: '#fff', fill: '#fff' }}/>}
              label="Documents"
              backgroundColor={pathN.indexOf('/documents') > -1 ? 'rgba(0, 0, 0, 0.2)' : null}
              labelStyle={pathN.indexOf('/documents') > -1 ? { color: '#fff', fontWeight: 'bold' } : { color: '#fff' }}
              disabled={pathN.indexOf('documents') > -1}
              onClick={this.goToDocuments}
            />
            <FlatButton
              icon={<InternalNoteIcon style={{ color: '#fff', fill: '#fff' }}/>}
              label={`Internal Notes${notesCount ? ` (${notesCount})` : ''}`}
              backgroundColor={pathN.indexOf('/notes') > -1 ? 'rgba(0, 0, 0, 0.2)' : null}
              labelStyle={pathN.indexOf('/notes') > -1 ? { color: '#fff', fontWeight: 'bold' } : { color: '#fff' }}
              disabled={pathN.indexOf('notes') > -1}
              onClick={this.goToNotes}
            />
            <FlatButton
              icon={<ActivityIcon style={{ color: '#fff', fill: '#fff' }}/>}
              label="Activities"
              backgroundColor={pathN.indexOf('/activities') > -1 ? 'rgba(0, 0, 0, 0.2)' : null}
              labelStyle={pathN.indexOf('/activities') > -1 ? { color: '#fff', fontWeight: 'bold' } : { color: '#fff' }}
              disabled={pathN.indexOf('activities') > -1}
              onClick={this.goToActivities}
            />
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
          <div style={{ width: '20%', paddingTop: '1em' }}>
            <Paper style={{ padding: '1em' }}>
              <PartnerNode
                forLeftNav
                isReceiver
                forSupplier
                style={{ marginBottom: '4px' }}
              />
              {
                !isHealthAndSafety && (
                  <div style={{ fontWeight: 'bolder', marginTop: '1em' }}>Contracting Period</div>
                )
              }
              {
                !isHealthAndSafety && (
                  <div style={{ margin: '0.5em 0 1em 0' }} className="flex-tc-sb">
                    {startDate ? moment.utc(new Date(startDate)).format('MMM DD YYYY') : ''} - {endDate ? moment.utc(new Date(endDate)).format('MMM DD YYYY') : ''}
                    <JiraFlatButton icon={<EditIcon/>} onClick={this.updateContractPeriod} label="Edit"/>
                  </div>
                )
              }
            </Paper>
            <Paper style={{ padding: '1em', marginTop: '1em' }}>
              <div className="flex-tc-sb" style={{ marginBottom: '1em' }}>
                <b>Assignee:&nbsp;</b>
                <UpdateAssignee
                  contractId={contractId}
                  assignee={assignee}
                  isContainer
                />
              </div>
              <div className="flex-tc-sb" style={{ marginBottom: '1em' }}>
                <b>Status:&nbsp;</b><UpdateRateConversionStatus
                  contractId={contractId}
                  rateConversionStatus={rateConversionStatus}
                />
              </div>
              <div className="flex-tc-sb">
                <b>Priority:&nbsp;</b>
                <UpdateRateConversionPriority
                  contractId={contractId}
                  priority={priority}
                />
              </div>
            </Paper>
            <Paper style={{ padding: '1em', marginTop: '1em' }}>
              <div style={{ fontWeight: 'bolder' }}>Rate Submission Deadline</div>
              <div style={{ marginBottom: '1em' }}>{ deadlineDate ? moment.utc(new Date(deadlineDate)).format('MMMM DD, YYYY') : 'NA' }</div>
              {
                Boolean(mostRecentSentActivity) && (
                  <div style={{ marginBottom: '1em' }}>
                    <Toggle
                      toggled={shouldSendReminders}
                      onClick={this.onClickShouldSendReminders}
                      label={`Auto Reminders: ${shouldSendReminders ? 'ON' : 'OFF'}`}
                      labelStyle={{ fontWeight: 'bolder' }}
                    />
                  </div>
                )
              }
              {
                (() => {
                  if (shouldSendReminders && mostRecentSentActivity) {
                    if (reminderDates[0] && reminderBasicRequirementMet) {
                      return (
                        <div style={{ marginBottom: '1em' }}>
                          <div style={{ fontWeight: 'bolder' }}>Next Scheduled Reminder:</div>
                          <div>{moment(reminderDates[0].date).format('MMMM DD, YYYY')}</div>
                        </div>
                      );
                    }
                    return (
                      <div style={{ marginBottom: '1em' }}>
                        <div style={{ fontWeight: 'bolder' }}>No scheduled reminder</div>
                        <div
                          style={{
                            marginTop: '8px',
                            backgroundColor: '#fafafa',
                            border: '1px solid #e0e0e0',
                            borderRadius: '4px',
                            padding: '8px',
                          }}
                        >
                          Requirements for Auto Reminders:
                          {
                            Object.keys(reminderRequirements).map(label => (
                              <div key={label} className="flex-center" style={{ fontSize: '10px' }}>
                                {
                                  reminderRequirements[label]
                                  ? <CheckIcon style={{ color: '#00bcd4', width: '16px', minWidth: '16px' }} />
                                  : <CheckIcon style={{ color: '#e0e0e0', width: '16px', minWidth: '16px' }} />
                                }
                                {
                                  label.indexOf('Company Settings') > -1
                                  ? (
                                    <span>
                                      Auto Reminder <Link to="/settings/contracting-settings">Company Settings</Link> are turned on and matches the dates
                                    </span>
                                  )
                                  : label
                                }
                              </div>
                            ))
                          }
                        </div>
                      </div>
                    );
                  }
                })()
              }
              <div style={{ fontWeight: 'bolder' }}>Request Last Sent:</div>
              {
                Boolean(mostRecentSentActivity) ? (
                  <EmailTracking
                    inLeftNav
                    isSender
                    sentDate={mostRecentSentActivity.createdAt}
                    showRecipients={this.state.showRecipients}
                    clickShowRecipients={this.clickShowRecipients}
                    recipients={R.propOr([], 'to', mostRecentSentActivity)}
                    rawEvents={R.propOr({}, 'events', mostRecentSentActivity)}
                  />
                ) : 'NA'
              }
              <JiraFlatButton
                style={{ width: '100%', marginTop: '16px' }}
                labelStyle={{ padding: '0 4px', color: '#00bcd4' }}
                label={deadlineDate ? 'Resend Request' : 'Send Request'}
                onClick={this.resendContract}
              />
            </Paper>
          </div>
          <div style={{ padding: '1em 0 0 1em', width: '80%' }}>
            {children}
          </div>
        </div>
        <ResendContract/>
        <AddEditContractDialog reducerName="contractActivitiesProducts"/>
        <LoadingOverlay loading={!this.props.contractId}/>
      </div>
    );
  }
}

CRBuyerView.propTypes = propTypes;

export default connect(({ contracting, user }, { params }) => {
  const leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  const rightSideContent = contracting.contractActivitiesProducts.get('rightSideContent').toJS();
  const activities = contracting.contractActivitiesProducts.get('activities').toJS();
  const notes = contracting.contractActivitiesProducts.get('notes').toJS();
  const mostRecentSentActivity = R.call(
    R.compose(
      R.find(o => o.contracts && o.contracts.find(c => c.action && c.action.indexOf('Request') > -1)),
      R.propOr([], 'messageArray')
    ),
    activities
  );
  return {
    contractId: leftNav.contractId,
    historyFeedId: leftNav.historyFeedId,
    leftNavLoaded: leftNav[`${params.contractId}Loaded`],
    notesCount: notes.length,
    viewingAs: leftNav.viewingAs,
    from: leftNav.from,
    to: leftNav.to,
    assignee: leftNav.assignee,
    priority: leftNav.priority,
    startDate: leftNav.startDate,
    endDate: leftNav.endDate,
    buyerChecked: leftNav.buyerChecked,
    rateConversionStatus: rightSideContent.rateConversionStatus,
    rateConversionSetting: rightSideContent.rateConversionSetting,
    isLatest: leftNav.isLatest,
    deadlineDate: rightSideContent.deadlineDate,
    shouldSendReminders: rightSideContent.shouldSendReminders,
    createdAt: rightSideContent.createdAt,
    contractingRemindersSettings: user.getIn(['companySettings']).contractingReminders,
    buyerInfo: rightSideContent.buyerInfo,
    files: rightSideContent.files,
    respondedContracts: leftNav.respondedContracts,
    lastSent: leftNav.lastSent,
    mostRecentSentActivity,
    payloadForResend: {
      contractId: leftNav.contractId,
      to: leftNav.to,
      toEmails: leftNav.toEmails,
      resendToEmails: leftNav.toEmails,
      partner: R.pathOr({}, ['partners', 0], leftNav),
      deadlineDate: rightSideContent.deadlineDate,
    },
  };
}, {
  getContractDetails: getContractDetailsAction,
  getContractLeftNav: getContractLeftNavAction,
  openResendContractDialog: payload => ({ type: 'CHANGE_RESEND_CONTRACT_DIALOG_STATE', payload }),
  push: pushAction,
  goBack: goBackAction,
  openAddEditContractDialog: payload => ({ type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE', payload }),
  updateWorkspace: payload => ({ type: '[contract-request] UPDATE_CONTRACTING_WORKSPACE', payload }),
  getHistoryFeeds: getHistoryFeedsAction,
  getNotes: getNotesAction,
})(CRBuyerView);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/contract-request-buyer-view/router.jsx